module.exports = __webpack_public_path__ + "img/ill-2.594b1ee1.svg";